module.exports = __webpack_public_path__ + "src/assets/textures/env/hut/bucket_256_bake.png";